import R14, { AsyncStorage } from "../core";
import DateUtils from "../utils/DateUtils";
import { MSG_TYPE } from "../constant/app.data.constant";
import CommonUtility from "../utils/CommonUtility";
export default class DashboardDomain extends R14.Domain {
  constructor(props) {
    super(props);
    this.state = {
      compiledMsgList: [],
      newBillCount: 0,
      overdueBillCount: 0,
      outstandingBillCount: 0,
      newPAMCount: 0,
      acceptPAMCount: 0,
      rejectPAMCount: 0,
      filterBills: [],
      isFilterOpen: false,
      headerSearchList: [],
      IsScannerVisible: false,
      // PCH
      submittedBillCount: 0,
      lastReadDateTime: null,
      dateTimeHistorys: [],
      isBlockNavigation: false,
      messages: {},
      selectedScreen: "RTP"
    };
  }

  async getMessageThread(threadId, profile, isValidPAM = false, totalCount) {
    try {
      const options = {threadId, profile, isValidPAM, totalCount}
      let res = await this.dm.queryDomain.middleware(this.api.qry(
        `query GetBillerFromThread($threadId: String!, $profile: String, $isValidPAM: Boolean, $totalCount: Int) {
          getBillerFromThread(threadId: $threadId, profile: $profile, isValidPAM: $isValidPAM, totalCount: $totalCount,) {
            success message error data
          }
        }`,
        options
      ));

      let msgDetails = res.data.getBillerFromThread;
      if(msgDetails && msgDetails.data) msgDetails = JSON.parse(msgDetails.data);
      else msgDetails = null;
      if (!!msgDetails && !isValidPAM) {
        let msg = msgDetails.messages.sort((a, b) =>
          new Date(a.envelope.messageHeader.messageDateTime) - new Date(b.envelope.messageHeader.messageDateTime)
        )
        msgDetails.messages = msg
      }
      return msgDetails;
    } catch (error) {
      console.log("Messages  ::: ", error);
    }
  }

  async getBillerFromThread(threadId, reload = false, totalCount) {
    const { messages } = this.state;
    try {
      if (!!messages && !!messages[threadId] && !!!reload)
        return messages[threadId];
      else {
        const isValidPAM = true;
        let msgDetails = await this.getMessageThread(threadId, "requestToPay" ,isValidPAM, totalCount);
        if (!!msgDetails) {
          let msg = msgDetails.messages;
          msgDetails.messages = msg.filter(
            (message) =>
              !!message.envelope.messageBody &&
              (!message.envelope.messageBody.subMessageType ||
                message.envelope.messageBody.subMessageType === "NoteToPayer" ||
                message.envelope.messageBody.subMessageType === "NoteToBiller")
          );
        }

        let obj = {}
        obj[threadId] = msgDetails;
        this.setState({
          messages: obj
        })
        return obj[threadId];
      }
    } catch (error) {
      console.log("Messages  ::: ", error);
    }
  }

  async setCompiledMsgList(options = {}) {
      let data = await this.syncRTPBills(options);
      if (!!data) {
        this.setState({
          compiledMsgList: data.bills,
          filterBills: data.bills,
          headerSearchList: data.bills,
          newBillCount: data.newCount,
          outstandingBillCount: data.outstandingCount,
          overdueBillCount: data.overDueCount,
          newPAMCount: data.newPAMCount,
          acceptPAMCount: data.acceptPAMCount,
          rejectPAMCount: data.rejectPAMCount,
          bookmark: data.bookmark,
        });
      }
    
    const { isSearchOpen, textInSearchBox, currentOpenScreen } = this.dm.userSearchDomain.state;
    if (isSearchOpen) this.dm.userSearchDomain.keyTypeSearch(textInSearchBox, currentOpenScreen);
    return {
      nodes: data.bills,
      totalCount: data.totalCount,
    }
  }

  async setCompiledBookmarkMsgList(options = {}) {
    options.screen = "dashboard";
    let data = await this.syncRTPBills(options);
    if (!!data) {
      this.setState({
        compiledMsgList: data.bills,
        filterBills: data.bills,
        headerSearchList: data.bills,
        newBillCount: data.newCount,
        outstandingBillCount: data.outstandingCount,
        overdueBillCount: data.overDueCount,
        newPAMCount: data.newPAMCount,
        acceptPAMCount: data.acceptPAMCount,
        rejectPAMCount: data.rejectPAMCount,
        bookmark: data.bookmark,
      });
    }
  
  const { isSearchOpen, textInSearchBox, currentOpenScreen } = this.dm.userSearchDomain.state;
  if (isSearchOpen) this.dm.userSearchDomain.keyTypeSearch(textInSearchBox, currentOpenScreen);
  return data.bookmark;
}

  async addUpdateBookmark(el) {
    let res = !!el.uid ? await this.updateBill({ bookmark: el.bookmark, uid: el.uid }, "uid bookmark") : null;
    return res;
  }

  async resetDashboardDomain() {
    await AsyncStorage.clear();
    // await AsyncSessionStorage.clear();
    this.setState({
      compiledMsgList: [],
      newBillCount: 0,
      overdueBillCount: 0,
      outstandingBillCount: 0,
      newPAMCount: 0,
      acceptPAMCount: 0,
      rejectPAMCount: 0,
      filterBills: [],
      isFilterOpen: false,
      headerSearchList: [],
      IsScannerVisible: false,
      sessionInActive: false,
      submittedBillCount: 0,
      lastReadDateTime: null,
      dateTimeHistorys: [],
      selectedBlock: [],
      isBlockNavigation: false
    });

    await this.dm.notificationDomain.setState({ notifications: [], notificationCount: 0, notificationThreadIds: [], reCalled: false });
    await this.dm.billerDirectoryDomain.setState({ pamList: [] });
    await this.dm.user.setState({ subuserItems: [], currentPage: 1 });
    await this.dm.simpleMessage.setState({ simpleMessage: [], searchSimpleMessage: [] });
    await this.dm.userLoginDomain.setState({ socialLoginProfile: null, socialLoginType: null });
    await this.dm.miscellaneousDomain.setState({ countries: [] });
    await this.dm.userSession.setState({ pchRegistrationTypeProvider: false, pchRegistrationTypePatient: false, isLoggedOut: false });
    await this.dm.userSearchDomain.setState({ isAlreadyOpen: false, isSearchOpen: false, textInSearchBox :"" });

  }

  async updateBill(input, fields = "uid") {
    let user = await this.dm.rest.getUser()
    input.actionBy = user.pid;
    await CommonUtility.htmlDecode(input);
    try {
      let res = await this.api.mutate(
        `
      mutation PutBillDetail($input: UpdateBillDetailInput) {
        putBillDetail(input: $input){
          billDetail {
            ${fields}
          }
          success
        }
      }`,
        { input }
      );
      let billDetail = res.data.putBillDetail.billDetail;
      return billDetail;
    } catch (error) {
      return error;
    }
  }

  async updateBillCount(compiledMsgList, filterBills) {
    this.setState({
      compiledMsgList,
      filterBills,
      newBillCount: compiledMsgList.filter((el) => el.billStatus === "New" && el.paymentStatus !== "In Process").length,
      outstandingBillCount: compiledMsgList.filter((el) => el.billStatus === "Outstanding" && el.paymentStatus !== "In Process").length,
      overdueBillCount: compiledMsgList.filter((el) => el.billStatus === "Overdue" && el.paymentStatus !== "In Process").length,
    });
  }

  async getBillHistory(options, fieldsStr = "uid payerId billerId billerUid threadId billDate billAmount dueDate subject amountPaid amountDue billStatus isExtentionRequested isExtentionApproved fullPaidAndDeclined bookmark rtpMessageType extentionApprovedDate extentionRequestedDate extentionDeclinedDate isExtentionDeclined paymentStatus isFailedPayment failDate failReason lastPaidAmount transactionId paymentMode accountNumber paymentOption { merchantAccountNumber } paymentType endToEndIdentification currency additionalInformation allowedRtpResponseTypes") {
    if (!fieldsStr) throw new Error("Bill Details Domain Find Error: No fields found");
    let defult = {
      sort: { field: "billDate", order: "DESC" },
      page: 1,
      resultsPerPage: 1000
    };
    let opt = { ...defult, ...options };
    let result = await this.dm.queryDomain.middleware(this.api.qry(
      `query GetBillHistory($filter: BillDetailFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
          getBillHistory(filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
          totalCount @include(if: true)
          nodes {
              ${fieldsStr}
            }
          }
        }`,
      opt
    ));
    
    result = !!result.data && !!result.data.getBillHistory ? result.data.getBillHistory : {};
    let res = !!result && !!result.nodes ? result.nodes : [];
    let list = await this.dm.rest.getBillers();
    for (let i = 0; i < res.length; i++) {
      let biller = list.find(x => x.uid === res[i].billerUid);
      res[i].biller = biller;
    };
    return {
      nodes: res,
    };
  }

  async syncRTPBills(options, fieldsStr = "uid payerId billerId billerUid threadId billDate billAmount dueDate subject amountPaid amountDue billStatus isExtentionRequested isExtentionApproved fullPaidAndDeclined bookmark rtpMessageType extentionApprovedDate extentionRequestedDate extentionDeclinedDate isExtentionDeclined paymentStatus isFailedPayment failDate failReason lastPaidAmount transactionId paymentMode accountNumber paymentOption { merchantAccountNumber } paymentType endToEndIdentification currency additionalInformation allowedRtpResponseTypes") {
    if (!fieldsStr) throw new Error("Bill Details Domain Find Error: No fields found");
    let defult = {
      sort: { field: "billDate", order: "DESC" },
      page: 1,
      resultsPerPage: 1000
    };
    let opt = { ...defult, ...options };
    let result = await this.dm.queryDomain.middleware(this.api.qry(
      `query SyncRTPBills($screen: String, $search: String, $filter: BillDetailFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
          syncRTPBills(screen: $screen, search: $search, filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
          newCount
          outstandingCount
          overDueCount
          newPAMCount
          acceptPAMCount
          rejectPAMCount
          bookmarkedResultSet
          {
            totalCount @include(if: true)
            nodes {
              ${fieldsStr}
            }
          }
          billDetailResultSet
          {
            totalCount @include(if: true)
            nodes {
                ${fieldsStr}
              }
            }
          }
        }`,
      opt
    ));
    
    result = !!result.data && !!result.data.syncRTPBills ? result.data.syncRTPBills : {};
    let res = !!result.billDetailResultSet && !!result.billDetailResultSet.nodes ? result.billDetailResultSet.nodes : [];
    let list = await this.dm.rest.getBillers();
    for (let i = 0; i < res.length; i++) {
      let biller = list.find(x => x.uid === res[i].billerUid);
      res[i].biller = biller;
    }

    /** For bookmark */
    let resBookmark = !!result.bookmarkedResultSet && !!result.bookmarkedResultSet.nodes ? result.bookmarkedResultSet.nodes : [];
    for (let i = 0; i < resBookmark.length; i++) {
      let biller = list.find(x => x.uid === res[i].billerUid);
      resBookmark[i].biller = biller;
    }
    return {
      newCount: result.newCount,
      outstandingCount: result.outstandingCount,
      overDueCount: result.overDueCount,
      newPAMCount: result.newPAMCount,
      acceptPAMCount: result.acceptPAMCount,
      rejectPAMCount: result.rejectPAMCount,
      bills: res,
      totalCount: result.billDetailResultSet?.totalCount || 0,
      bookmark: {
        nodes: resBookmark,
        totalCount: result.bookmarkedResultSet?.totalCount || 0,
      }
    };
  }

  async getBill(
    threadId,
    fieldsStr = "uid payerId billerId billerUid threadId billDate billAmount dueDate subject amountPaid amountDue billStatus isExtentionRequested isExtentionApproved fullPaidAndDeclined bookmark rtpMessageType extentionApprovedDate extentionRequestedDate extentionDeclinedDate isExtentionDeclined paymentStatus isFailedPayment failDate failReason lastPaidAmount transactionId paymentMode accountNumber paymentOption { merchantAccountNumber } paymentType endToEndIdentification currency additionalInformation allowedRtpResponseTypes"
     ) {
      
      if (!fieldsStr) throw new Error("Bill Details Domain Find Error: No fields found");
      let result = await this.dm.queryDomain.middleware(await this.api.qry(
        `query BillDetail($threadId: String!){
          getRTPBill(threadId: $threadId){
            message
            billDetail {
              ${fieldsStr}
            }
          }
        }`,
        {threadId: threadId}
      ));
      result = !!result.data && !!result.data.getRTPBill ? result.data.getRTPBill : {};
      
      let list = await this.dm.rest.getBillers();
      let biller = !!list && list.length ? list.find(x => x.uid === result.billDetail.billerUid) : {};
      if(biller && result.billDetail) {
        result.billDetail.biller = biller;
        result.message = JSON.parse(result.message);
        let f_messages = result.message.messages.filter(
          (el) =>
            el.envelope.messageBody &&
          el.envelope.messageBody.messageType !== MSG_TYPE.NOTE_TO_BILLER &&
          el.envelope.messageBody.messageType !== MSG_TYPE.NOTE_TO_PAYER
        );
        const firstElement = f_messages.filter((el) => el.envelope.messageBody && el.envelope.messageBody.messageType === MSG_TYPE.REQ_PAY)[0];
        
        result.billDetail = this.billObject(result.billDetail, firstElement);
      }
      return result;
  }

  async payBill(payload, fields = "uid payerId billerId billerUid threadId billDate billAmount dueDate subject amountPaid amountDue billStatus isExtentionRequested isExtentionApproved fullPaidAndDeclined bookmark rtpMessageType extentionApprovedDate extentionRequestedDate extentionDeclinedDate isExtentionDeclined paymentStatus isFailedPayment failDate failReason lastPaidAmount transactionId paymentMode accountNumber paymentOption { merchantAccountNumber } paymentType endToEndIdentification currency additionalInformation allowedRtpResponseTypes") {
    try {
      let res = await this.api.mutate(
        ` mutation PayBill($payload: String!){
           payBill(payload: $payload){
            message
             billDetail {
              ${fields}
            }
            success
          }
        }`,
        { payload }
      );
      let bill = res.data.payBill;
      let list = await this.dm.rest.getBillers();
      let biller = !!list && list.length ? list.find(x => x.uid === bill.billDetail.billerUid) : {};
      if (biller && bill.billDetail) {
        bill.billDetail.biller = biller;
        bill.message = JSON.parse(bill.message);
        let f_messages = bill.message.messages.filter(
          (el) =>
            el.envelope.messageBody &&
            el.envelope.messageBody.messageType !== MSG_TYPE.NOTE_TO_BILLER &&
            el.envelope.messageBody.messageType !== MSG_TYPE.NOTE_TO_PAYER
        );
        const firstElement = f_messages.filter((el) => el.envelope.messageBody && el.envelope.messageBody.messageType === MSG_TYPE.REQ_PAY)[0];
        bill.billDetail = this.billObject(bill.billDetail, firstElement);
      }
      return bill;
    } catch (error) {
      return error;
    }
  }

  billObject = (billDetail, data) => {
    const { messageBody, threadHeader, messageHeader } = data.envelope;
    const { messageDateTime, messageId, recipientPid, senderPid, senderName } = messageHeader;
    const { amount, remittanceInformation, transactionStatus} = messageBody;
    const { threadId, threadDateTime, originatorPid } = threadHeader;
    let paymentOption = {};
    let bill = {
        ...billDetail,
        threadHeader,
        messageHeader,
        messageId,
        originatorPid,
        recipientPid,
        senderPid,
        senderName,
        paymentOptions: paymentOption,
        threadDateTime: threadDateTime,
        messageDateTime: messageDateTime,
        billerName: threadId.split("#")[0],
        amount: amount.dueAmount.toFixed(2),
        rtpStatus: billDetail.rtpMessageType,
        paidAmount: billDetail.amountPaid,
        billingPeriod: remittanceInformation.structured
            ? `${DateUtils.formatDate(remittanceInformation.structured.billingPeriod.billingPeriodFrom)} - ${DateUtils.formatDate(
                remittanceInformation.structured.billingPeriod.billingPeriodTo
            )}`
            : null,
        sortCode: transactionStatus,
        messageMeta: data.messageMeta,
    };
    return bill;
}

  async getAllDateTimeHistory(fieldsStr = "uid payerId simpleMessageLastDateTime pamMessageLastDateTime billLastDateTime activeBillerLastDateTime") {
    const { dateTimeHistorys } = this.state;
    if (!!dateTimeHistorys && dateTimeHistorys.length > 0)
      return dateTimeHistorys;
    else {
      let result = await this.api.qry(
        `query getDateTimeHistorys{
          getDateTimeHistorys{
            nodes {
              ${fieldsStr}
            }
        }
      }`
      );
      let dateHistory = result.data?.getDateTimeHistorys?.nodes;
      this.setState({
        dateTimeHistorys: dateHistory
      })
      return dateHistory;
    }
  }

  async updateMsgDateHistory(input, fields = "uid") {
    if (!!input.uid) {
      await CommonUtility.htmlDecode(input);
      try {
        this.api.mutate(`mutation PutDateTimeHistory($input: UpdateDateTimeHistoryInput) {
        putDateTimeHistory(input: $input){
          success
        }
      }`,
          { input }
        );
      } catch (error) {
        return error;
      }
    }
  }

  async createDateTimeHistory(input, fields = "uid") {
    await CommonUtility.htmlDecode(input);
    try {
      let res = await this.api.mutate(
        `
      mutation PostDateTimeHistory($input: CreateDateTimeHistoryInput) {
        postDateTimeHistory(input: $input){
          dateTimeHistory {
            ${fields}
          }
          success
        }
      }`,
        { input }
      );
      return res.data.postDateTimeHistory.dateTimeHistory;
    } catch (error) {
      return error;
    }
  }
  
  async getBillReference(options, fieldsStr = "uid") {
    let defult = {
      sort: { field: "billDate", order: "DESC" }
    };
    let opt = { ...defult, ...options };
    let result = await this.api.qry(`query BillDetails($filter: BillDetailFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
          billDetails(filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
            totalCount @include(if: true)
            nodes {
              ${fieldsStr}
            }
          }
        }`,
      opt
    );
    let res = !!result.data.billDetails && !!result.data.billDetails.nodes ? result.data.billDetails.nodes : [];
    return res;
  }  
}
